var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerclock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99967 20.7498C4.21321 20.7498 0.333008 16.8696 0.333008 12.0832C0.333008 7.2967 4.21321 3.4165 8.99967 3.4165C13.7861 3.4165 17.6663 7.2967 17.6663 12.0832C17.661 16.8674 13.7839 20.7445 8.99967 20.7498ZM8.99967 5.58317C5.40982 5.58317 2.49967 8.49332 2.49967 12.0832C2.49967 15.673 5.40982 18.5832 8.99967 18.5832C12.5895 18.5832 15.4997 15.673 15.4997 12.0832C15.4955 8.49505 12.5878 5.58735 8.99967 5.58317ZM10.083 13.1665H7.91634V7.74984H10.083V13.1665ZM16.9004 6.34909L14.7338 4.18242L16.2656 2.65059L18.4323 4.81725L16.9015 6.348L16.9004 6.34909ZM12.2497 2.33317H5.74967V0.166504H12.2497V2.33317Z",
    fill: "#481B3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerclock);
export default __webpack_public_path__ + "static/media/timerclock.ca9b9b375fb15d95c183918fe34d1980.svg";
export { ForwardRef as ReactComponent };